import React, { useState } from "react";
import FexLayout from "../../components/LayoutFlex";
import { Box, Text } from "@edricphan2022/uikit";
import { ArrFaq } from "./config";
import ContentHeader from "../../components/ContentHeader";
import CollapseOrbit from "../../components/CollapseOrbit";
import styled from "styled-components";
import ArrDown from "../../assets/Home/arrowDown.png";
import BgFaq from "../../assets/Home/FAQ/panner.png";

const OrbitFaq: React.FC = () => {

  const [ShowDetail , setShowDetail] = useState(undefined)

  return (
    <FexLayout className="orbit-faq">
      <TitleWapper>
        <h2>Still have questions?</h2>
        <h1>Read our FAQ</h1>
        <BoxImg>
          <img src={BgFaq} alt=''/>
        </BoxImg>
      </TitleWapper>
      <BoxWapper>
        {ArrFaq().map(({ title, description }, i, { length }) => (
          // @ts-ignore
          <Wapper key={title} onClick={()=>{ i === ShowDetail ? setShowDetail(undefined) : setShowDetail(i) }} >
            <Q>
              <h3>Q{i + 1}</h3>
            </Q>
            <Content>
              <Title imgTrf={i === ShowDetail} >
                <h4>{title}</h4>
                <img src={ArrDown} alt="" />
              </Title>
              <Des Padd={ ShowDetail === i ? '10px 16px 16px' : '0px'} show={ShowDetail === i} >
                {description.map((desc) => {
                  return <p key={desc}>{desc}</p>;
                })}
              </Des>
            </Content>
          </Wapper>
        ))}
      </BoxWapper>
    </FexLayout>
  );
};

const TitleWapper = styled(Box)`
  width: 42.5%;
  h1,h2{
    color: #333333;
    font-size: 48px;
    font-family: ManropeBold;
    font-weight: 700;
  }
  h1{
    text-transform: uppercase;
  }
  h2{
    font-size: 30px;
    font-family: ManropeRegular;
    font-weight: 400;
  }
  .orbit-faq-panner{
    width: 100%;
  }
  @media only screen and (max-width: 1132px){
    width: 40%;
    h1{
      font-size: 36px;
      margin-bottom: 30px;
    }
    h2{
      font-size: 24px;
    }
  }
  @media only screen and (max-width: 743px){
    width: 100%;
  }
`
const BoxImg = styled(Box)`
  padding-left: 20px;
  padding-top: 30px;
  img{
    max-width: 493px;
    width: 100%;
  }
  @media only screen and (max-width: 743px){
    width: 80%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
  }
`
const BoxWapper = styled(Box)`
  width: 57.5%;
  margin-top: 60px;
  max-width: 829px;
  @media only screen and (max-width: 743px){
    width: 100%;
  }
`;

const Wapper = styled(Box)`
  width: 100%;
  display: flex;
  alignitems: flex-start;
  min-height: 60px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px #dedede;
  border-radius: 6px;
  margin-bottom: 18px;
`;

const Q = styled(Box)`
  background-color: #f7da57;
  padding-top: 21px;
  width: 55px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-radius: 6px 0px 0px 6px;
  h3 {
    font-size: 18px;
    font-weight: 700;
    font-family: ManropeBold;
  }
`;

const Content = styled(Box)`
  width: calc(100% - 55px);
`;
const Title = styled(Box)<{imgTrf ?: boolean}>`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  justify-content: space-between;
  h4 {
    font-size: 18px;
    font-family: ManropeRegular;
    font-weight: ${({imgTrf})=> imgTrf ? '700' : '400'};
    color: ${({imgTrf})=> imgTrf ? 'black' : '#333333'};
  }
  img {
    max-width: 22px;
    max-height: 14px;
    transform: ${({imgTrf})=> imgTrf ? 'rotateZ(180deg)' : 'rotateZ(0deg)' };
    transition: all 0.3s linear;
  }
  @media only screen and (max-width: 1133px){
    h4{
      font-size: 12px;
    }
  }
  @media only screen and (max-width: 743px){
    h4{
      font-size: 14px;
    }
  }
`;
const Des = styled(Box)<{Padd?:string , show?: boolean }>`
  width: 100%;
  padding: ${({Padd})=> Padd} ;
  max-height: ${({show})=> !show ? '0px' : 'fit-content'};
  overflow: hidden;
  p{
    font-size: 16px;
    font-family: ManropeRegular;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    margin-bottom: 10px;
  }
  @media only screen and (max-width: 1133px){
    p{
      font-size: 12px;
    }
  }
`;

export default OrbitFaq;
